import { ReactSVG } from "react-svg";
import { useSelector } from "react-redux";
import { ModalHeaderProps } from "./types";
import { classNames, useTranslate } from "helpers";
import { getActiveUser } from "services/api/users/redux/selectors";

const ModalHeader: React.FC<ModalHeaderProps> = (props: ModalHeaderProps) => {
  const { icon, title, badge, onHide } = props;

  const { t } = useTranslate();
  const activeUser = useSelector(getActiveUser);
  const user = activeUser?.user;

  const initials = user
    ? `${user.firstName?.charAt(0) ?? ""}${user.lastName?.charAt(0) ?? ""}`.toUpperCase()
    : "";

  const fullName = user ? `${user.firstName ?? ""} ${user.lastName ?? ""}`.trim() : "";

  const handleHideClick = () => {
    if (onHide) {
      document.body.classList.remove("overflow-hidden");
      onHide();
    }
  }

  return (
    <div className={classNames(
      "flex items-center w-full flex-shrink-0 relative",
      title ? "bg-white py-5 px-4 border-b border-slate-200" : "py-3 px-4"
    )}>
      {icon && (
        <div className="w-6 h-6 mr-3 flex-shrink-0">
          <ReactSVG src={icon} className="w-6 h-6" />
        </div>
      )}

      <p className="text-base font-medium text-slate-900 truncate">
        {title && t(title)}
      </p>

      {badge && <div className="ml-3 flex-shrink-0">{badge}</div>}

      {fullName && (
        <div className="flex items-center gap-2 ml-auto mr-10 flex-shrink-0">
          <div className="w-7 h-7 rounded-full bg-slate-200 flex items-center justify-center text-[10px] font-semibold flex-shrink-0">
            {initials}
          </div>
          <span className="text-sm text-slate-900">
            {fullName}
          </span>
        </div>
      )}

      <button onClick={handleHideClick} className="absolute right-4 top-1/2 -translate-y-1/2">
        <ReactSVG
          src={"/media/icons/close.svg"}
          className="w-6 h-6 [&_svg]:stroke-gray-500"
        />
      </button>
    </div>
  );
};

export default ModalHeader;
